export const SuperUserSidebarData = [
    {
        title: 'Dashboard',
        path: '/admin/dashboard',
    },
    {
        title: 'Applications',
        subNav: [
            {
                title: 'New Applications',
                path: '/new_applications',
            },
            {
                title: 'Regional Approvals',
                path: '/regional_approvals',
            },
        ]
    },
    {
        title: 'Operations',
        subNav: [
            {
                title: 'Declined Applications',
                path: '/declined_applications',
            },
            {
                title: 'Responses',
                path: '/#',
                subNav: [
                    {
                        title: 'Update Response',
                        path: '/update_response',
                    },
                    {
                        title: 'Activation Response',
                        path: '/activation_response',
                    },
                    {
                        title: 'Messages Response',
                        path: '/messages_response',
                    },
                ],
            },
            {
                title: 'Regional Reports',
                path: '/regional_report_list',
            },

        ]
    },
    {
        title: 'Membership',
        subNav: [
            {
                title: 'Global Members',
                path: '/global_members',
            },
            {
                title: 'Regional Membership',
                path: '/admin_regional_members',
            },
            {
                title: 'Active Members',
                path: '/active_members',
            },
            {
                title: 'InActive Members',
                path: '/inactive_members',
            },
        ]
    },
    {
        title: 'Card Management',
        subNav: [
            {
                title: 'Global Cards',
                path: '/global_cards',
            },
            {
                title: 'Pending Cards',
                path: '/pending_cards',
            },
            {
                title: 'Pending Confirmation',
                path: '/pending_confirmation',
            },
        ]
    },
    {
        title: 'Accounts',
        path: '/#',
        subNav: [
            {
                title: 'Receipts',
                path: '/#',
                subNav: [
                    {
                        title: 'Manual Receipt',
                        path: '/manual_receipt',
                    },
                ],
            },
            {
                title: 'Payments',
                path: '/#',
                subNav: [
                    {
                        title: 'Payment Transactions',
                        path: '/payment_transactions',
                    },
                    {
                        title: 'Payment Clearance',
                        path: '/payment_clearance',
                    },
                    {
                        title: 'Payment Types',
                        path: '/payment_types',
                    },
                    {
                        title: 'Yearly Payments',
                        path: '/yearly_payments',
                    },
                ],
            },
            {
                title: 'Ledgers',
                path: '/#',
                subNav: [
                    {
                        title: 'Ledger Accounts',
                        path: '/ledger_accounts',
                    },
                    {
                        title: 'Yearly Ledgers',
                        path: '/yearly_ledgers',
                    },
                ],
            },
            {
                title: 'Expenditure',
                path: '/#',
                subNav: [
                    {
                        title: 'Expenditure Items',
                        path: '/expenditure',
                    },
                ],
            },
            {
                title: 'Revenue',
                path: '/#',
                subNav: [
                    {
                        title: 'Revenue Items',
                        path: '/revenue',
                    },
                ],
            },
            {
                title: 'Accounts Reports',
                path: '/#',
                subNav: [
                    {
                        title: '2M2 Payments',
                        path: '/2m2_payments',
                    },
                    {
                        title: 'Mandatory Payments',
                        path: '/mandatory_payments',
                    },
                    {
                        title: 'Ledger Balances',
                        path: '/ledger_balances',
                    },
                ],
            },
        ]
    },
    {
        title: 'System Admin',
        subNav: [
            {
                title: 'Users',
                subNav: [
                    {
                        title: 'Admin Users',
                        path: '/admin_users',
                    },
                    {
                        title: 'Portal Users',
                        path: '/portal_users',
                    },
                    {
                        title: 'Regional Presidents',
                        path: '/regional_presidents',
                    },
                ],
            },
            {
                title: 'Amendments',
                subNav: [
                    {
                        title: 'Capture Old Members',
                        path: '/capture_old_members',
                    },
                    {
                        title: 'Change Region',
                        path: '/change_region',
                    },
                    {
                        title: 'Member Update',
                        path: '/find_member',
                    },
                ],
            },
            {
                title: 'Roles',
                path: '/roles',
            },
            {
                title: 'General Setup',
                path: '/general_setup',
            },
        ]
    },
    {
        title: 'Log Out',
        path: '/admin_logout',
    },
];